import { PatientPayersActions } from 'src/redux/actions/constant';

const {
  GET_ALL_PATIENT_PAYER_REQUEST,
  GET_ALL_PATIENT_PAYER_SUCCESS,
  GET_ALL_PATIENT_PAYER_FAILURE,
  GET_ALL_PATIENT_PAYER_RESET,
} = PatientPayersActions;

const initialState: any = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
  currentPage: -1,
  pageNumber: 0,
  data: [],
};

export const getAllPatientPayersReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_PATIENT_PAYER_SUCCESS: {
      const newPageNumber = action.payload?.data?.number;
      if (state.currentPage + 1 === newPageNumber) {
        return {
          ...state,
          response: action.payload,
          loading: false,
          currentPage: newPageNumber,
          isError: false,
          errorMessage: '',
          data: [...state.data, ...action.payload?.data?.content],
          pageNumber: state.pageNumber + 1,
        };
      } else {
        return {
          ...state,
          response: action.payload,
          errorMessage: '',
          loading: false,
          isError: false,
          currentPage: newPageNumber,
          data: action.payload?.data?.content || [],
        };
      }
    }

    case GET_ALL_PATIENT_PAYER_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case GET_ALL_PATIENT_PAYER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_ALL_PATIENT_PAYER_RESET:
      return initialState;

    default:
      return state;
  }
};
